export default function getCOPScookie(parameter) {
  const cookiesArray = document.cookie.split('; ');
  const cookiesObject = cookiesArray.reduce((all, item) => {
    const [itemKey, itemValue] = item.split('=');
    all[itemKey] = itemValue; // eslint-disable-line no-param-reassign
    return all;
  }, {});
  const COPSCookie = cookiesObject['cops.environment'];
  if (COPSCookie) {
    const decodedCOPSCookie = JSON.parse(decodeURIComponent(COPSCookie));
    if (decodedCOPSCookie[parameter]) {
      return decodedCOPSCookie[parameter];
    }
  }
  return null;
}
